import { FC, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { apiAccountService } from '@api';
import Skeleton from '@components/common/skeleton';
import { Icon } from '@components/icons';
import { useNotificationsContext } from '@hooks/context/useNotificationsContext';
import { EEventName } from '@xeppt/xeppt-sdk/types/notification';
import { useApiMutation } from '@hooks/api/useApiMutation';
import { useUserContext } from '@hooks/context/useUserContext';

interface IProps {
    handleChoseOtherType: () => void;
}

const LinkCardSection: FC<IProps> = ({ handleChoseOtherType }) => {
    const { t } = useTranslation('sections', {
        keyPrefix: 'link_card_bank.link_card'
    });
    const [isDone, setIsDone] = useState(false);
    const navigate = useNavigate();
    const { lastNotificationType } = useNotificationsContext();
    const { refetchAccount } = useUserContext();

    useEffect(() => {
        if (lastNotificationType === EEventName.EPSCardLinked) {
            setIsDone(true);
        }
    }, [lastNotificationType]);

    const { data: iframeLink } = useApiQuery({
        method: () => apiAccountService.getEPSCardIFrameLink(),
        isInitialRequest: false
    });

    const { handleRequest: handleAddLinkedCard } = useApiMutation({
        method: (id: string) => apiAccountService.linkEPSCard(id),
        onSuccess: () => {
            setIsDone(true);
            refetchAccount();
        }
    });

    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event.data.type === 'card_successfully_linked') {
                const dataObject = event.data;
                if (dataObject.data.cardId) {
                    handleAddLinkedCard(dataObject.data.cardId);
                }
            }
        });
        return () => {
            window.removeEventListener('message', () => {});
        };
    }, []);

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <Skeleton className={styles.skeleton} />
            {iframeLink && (
                <iframe
                    className={`${styles.iframe} iframe_card`}
                    src={`${iframeLink}&test=true`}
                />
            )}
            {isDone && (
                <Button
                    className={styles.success_button}
                    variant="primary"
                    onClick={() => navigate(routes.dashboard)}>
                    Done
                </Button>
            )}
            <button className={styles.back} onClick={handleChoseOtherType}>
                <Icon name="arrow_left" />
                <p>{t('link_bank')}</p>
            </button>
        </motion.div>
    );
};

export default LinkCardSection;
